import React, { useState } from 'react';
import $ from 'jquery';
import '../../common/EditUserProfile.css';
import Authenticator from '../../protocol/Authenticator';
import t from '../../i18n/I18n';
import ConnectionUtil from '../../util/session/ConnectionUtil';
import EditUser from '../../queries/user/EditUser';
import Portal from '../../common/Portal';
import Modal from '../../modals/Modal2';
import CollectionUtil from '../../queries/lightbox/CollectionUtil';
import LabelWithValueField from '../../common/LabelWithValueField';
import StringUtil from '../../util/StringUtil';
import ParamsUtil from '../../util/ParamsUtil';
import Storage from '../../protocol/Storage';
import { togglePageLoadPlaceholder } from '../../util/DOMUtil';
import PreviewAuthController from '../../controllers/preview/PreviewAuthController';
import AuthenticationController from '../../controllers/AuthenticationController';
import Authenticator2 from '../../auth/Authenticator2';

const ChangePassword  = ({onClose, onPasswordChange}) => {
    const [error,setError] = useState('');
    const [newPass, setNewPass] = useState('')
    const [confirmNewPass, setConfirmPass] = useState('')
    const [oldPass, setOldPass] = useState('')
    let userId = Authenticator.AUTH_DATA.username;
  
    const logout = () => {
        togglePageLoadPlaceholder(false);
        PreviewAuthController.logoutFromReviewServer();
        AuthenticationController.logout((resp) => {
          if (resp) {
            const globalUrl = resp.getGlobalLogoutURLs();
            if (globalUrl) {
              Authenticator2.AUTH_STORE.put(Authenticator2.GLOBAL_LOGOUT_URL, globalUrl[0]);
            }
            AuthenticationController.onLogoutResp();
          }
        });
      }

    const onEditUserSuccess = () => {
      onClose();
      let userId = ConnectionUtil.getUserId();
      $.get(
        ParamsUtil.appendAuthData(`${ConnectionUtil.getPreviewServerUrl()}/review/api/user/invalidate-avatar/${userId}`)
      ).always(() => {
        Storage.set('AVATAR_DC', Date.now());
        logout();
      });
    };
  
    const onEditUserFailed = (errorId) => {
      setError(errorId.toString());
    };
  
  
    const editAccount = () => {
      const editUserAccount = new EditUser();
      const promise = editUserAccount.editUser(
        userId,
        oldPass,
        newPass,
      );
      promise.then(onEditUserSuccess, onEditUserFailed);
    };
  
    const verifyValues = () => {
      let _passwordMatch = doesConfirmPasswordMatch(newPass, confirmNewPass);
      let _validOldPass = isValidValue(oldPass);
      let _validConfirmNewPass = isValidValue(confirmNewPass);
      let _validNewPass = isValidValue(newPass);
  
      if (_validOldPass || _validNewPass || _validConfirmNewPass) {
        if (!_validOldPass) {
          setError(t('OLD_PASSWORD_REQUIRED'));
        } else if (!_validNewPass) {
          setError(t('NEW_PASSWORD_REQUIRED'));
        } else if (!_validConfirmNewPass) {
          setError(t('CONFIRM_NEW_PASSWORD_REQUIRED'));
        } else if (!_passwordMatch) {
          setError(t('CONFIRM_NEW_PASSWORD_NOT_MATCH'));
        } else {
          editAccount();
        }
      } else {
        onClose();
      }
    };
  
    const doesConfirmPasswordMatch = (password, confirmPassword) => {
      return password === confirmPassword;
    };
  
    const isValidValue = (value) => {
      return StringUtil.isNotEmpty(value);
    };
  
    const showErrorMessage = () => {
      return <div style={styles.errorMessage}>{error}</div>;
    };
  
  
    const modalProps = {
      name: 'EditUserAccount',
      title: t('CHANGE_PASSWORD'),
      onClose,
      buttons: [
        { onClick: onClose, label: t('CANCEL'), type: 'CANCEL' },
        { onClick: verifyValues, label: t('SAVE'), type: 'PRIMARY' }
      ]
    };
  
    return (
      <Portal defaultOpen={true} closeOnEsc={true}>
          <Modal {...modalProps} closeOnEsc closeOnOutsideClick>
            <div>
              {!CollectionUtil.isLdapRealm() ? (
                <div style={{ display: 'inline-grid', width: '100%' }}>
                  <LabelWithValueField
                    labelName={t('OLD_PASSWORD')}
                    style={{ marginTop: '20px' }}
                    value={oldPass}
                    typeOfInput="password"
                    onChange={(oldPass) => setOldPass(oldPass)}
                  />
                  <LabelWithValueField
                    labelName={t('NEW_PASSWORD')}
                    style={{ marginTop: '20px' }}
                    value={newPass}
                    typeOfInput="password"
                    onChange={(newPass) => setNewPass(newPass )}
                  />
                  <LabelWithValueField
                    labelName={t('CONFIRM_NEW_PASSWORD')}
                    style={{ marginTop: '20px' }}
                    value={confirmNewPass}
                    typeOfInput="password"
                    onChange={(confirmNewPass) => setConfirmPass(confirmNewPass)}
                  />
                </div>
              ) : null}
              {error ? showErrorMessage() : null}
            </div>
          </Modal>
        </Portal>
    )
  }
  
  const styles = {
    userInfo: {
      height: '150px',
      width: '100%',
      borderRadius: '3px',
      backgroundColor: 'var(--dropdown-bg-selected)',
      paddingTop: '15px',
      marginBottom: '10px'
    },
    changePassword: {
      height: '19px',
      color: '#7A7A7A',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '19px',
      marginLeft: '5px'
    },
    passwordLabel: {
      height: '15px',
      color: '#B5B5B5',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: 600,
      letterSpacing: '1px',
      lineHeight: '15px',
      marginLeft: '5px',
      marginTop: '20px'
    },
    passValue: {
      width: '100%',
      padding: '0.5em',
      //color: '#000000',
      border: 'none',
      fontFamily: 'Montserrat',
      borderRadius: '2px',
      //backgroundColor: '#FFFFFF',
      boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
      fontSize: '16px',
      marginTop: '10px'
    },
    errorMessage: {
      color: '#DF2714',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      lineHeight: '18px',
      wordWrap: 'break-word',
      marginBottom: '20px'
    },
    editIcon: {
      float: 'right'
    },
    email: {
      height: '19px',
      color: '#B5B5B5',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      lineHeight: '19px',
      textAlign: 'center'
    }
  };
  
  export default ChangePassword;